import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { likeGame, unlikeGame } from '~/api';
import useToast from '~/store/useToast';
import { UpdateCharacterLikeMutationType } from '../character/useUpdateCharacterLike';

const useGameLikeMutation = () => {
  const { showToast } = useToast();

  return useMutation({
    mutationFn: ({
      operation,
      game_id,
    }: {
      game_id: number;
      operation: UpdateCharacterLikeMutationType;
    }) =>
      operation === 'like' ? likeGame({ game_id }) : unlikeGame({ game_id }),
    onError: (error) => {
      console.error(error);
      showToast('error', 'Failed to save like');
    },
  });
};

export default useGameLikeMutation;
